module.exports = __webpack_public_path__ + "img/encastedark.07fc127a.svg";